import store from '@/store'
import * as Network from '@/helpers/network'
import * as moment from 'moment'

export function getSchool(query) {
    return new Promise((resolve, reject) => {
        const sid =
            store.state.user.type == 'school' ||
            store.state.user.type == 'teacher' ||
            store.state.user.type == 'parent'
                ? store.state.user.sid
                : store.state.selectedSchool.id
        Network.getDataWidthRetry(`v1/schools/${sid}?${query}`)
            .then(({ data }) => {
                store.commit('setSchool', data)
                resolve(data)
            })
            .catch(error => {
                reject(error)
            })
    })
}
export function getFreeDays() {
    return new Promise((resolve, reject) => {
        let freeDays = []
        const firstYear = moment().format('YYYY')
        const secondYear = moment().add(1, 'Y').format('YYYY')
        Network.getDataWidthRetry(`v1/workdays/${firstYear}`)
            .then(({ data }) => {
                freeDays = data
                Network.getDataWidthRetry(`v1/workdays/${secondYear}`)
                    .then(({ data }) => {
                        freeDays.push(...data)
                        store.commit('setFreeDays', freeDays)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
            .catch(error => {
                reject(error)
            })
    })
}
export function getAccount() {
    return new Promise((resolve, reject) => {
        Network.getDataWidthRetry(`v1/accounts`)
            .then(({ data }) => {
                store.commit('setAccount', { account: data })
                resolve(data)
            })
            .catch(error => {
                reject(error)
            })
    })
}
